import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import GuidedPathUsersTable from './GuidedPathUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';

/**
 * Company Guided Path → Employees / Members.
 *
 * Engagement only, and no row opens anything. See GuidedPathUsersTable for what
 * is deliberately absent from it.
 */
const CGuidedPathUsers = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Guided Path | Shoorah</title>
      </Helmet>
      <GuidedPathUsersTable
        key={`${isB2BFansMode}-${department}`}
        tableName="company-guided-path-users"
        department={department}
      />
    </div>
  );
};

export default CGuidedPathUsers;
